import React, { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { toast } from "react-toastify";

const CustomerCoachingBookingStep4 = ({
  sportData,
  sessionRule,
  handleNext,
}: any) => {
  const navigate = useNavigate();
  const [check, setCheck] = useState(false);
  const { setting, errorMessage } = useAppSelector((state) => state.settings);

  const handleCancel = () => {
    navigate("/customer-dashboard");
  };

  const _contactProcess = setting?.contactProcess
    ?.split("\n")
    .map((paragraph) =>
      paragraph
        .trim()
        .split("\n")
        .map((line, i) => (
          <li className="bg-transparent border-0 list-group-item" key={i}>
            {line}
          </li>
        ))
    );

  if (errorMessage) {
    toast.error(errorMessage.message)
  }
  return (
    <>
      <Container fluid className="g-0">
        <Row className="row-mb g-4 align-items-center">
          <Col lg={12}>
            <div className="fs-5 fw-semibold mb-1 text-start">
              Rules of Session
            </div>
            <ol className="list-group list-group-flush list-group-numbered text-start">
              {sessionRule?.map((item: any) => {
                return (
                  <li
                    key={item.id}
                    className="bg-transparent border-0 list-group-item"
                  >
                    {item.rule.subject}
                  </li>
                );
              })}
            </ol>
            <div className="mt-3"></div>

            <div className="fs-5 fw-semibold mb-1 text-start">
              Rescheduling Policy <small>(Only For Session Booking)</small>:
            </div>
            <ol className="list-group list-group-flush text-start">
              <li className="bg-transparent border-0 list-group-item">
                {setting?.reschedulePolicy}
              </li>
            </ol>
            <div className="mt-3"></div>
            <div className="fs-5 fw-semibold mb-1 text-start">
              Cancellation Policy <small>(Only For Session Booking)</small>:
            </div>
            <ol className="list-group list-group-flush text-start">
              <li className="bg-transparent border-0 list-group-item">
                {setting?.cancellationPolicy}
              </li>
            </ol>
            <div className="mt-3"></div>
            <div className="fs-5 fw-semibold mb-1 text-start">
              Refund Policy <small>(Only For Session Booking)</small>:
            </div>
            <ol className="list-group list-group-flush text-start">
              <li className="bg-transparent border-0 list-group-item">
                {setting?.refundPolicy.split("\n").map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </li>
            </ol>
            <div className="mt-3"></div>
            <div className="fs-5 fw-semibold mb-1 text-start">
              Contact & Process :
            </div>
            <ol className="list-group list-group-flush text-start">
              {_contactProcess}
            </ol>
          </Col>
          <Col lg={2}>
            <Form.Check
              onChange={(e: any) => setCheck(e.target.checked)}
              checked={check}
              label="Accept & Proceed"
              name="accept"
              type="checkbox"
              id="accept"
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col lg={6} className="text-start">
            <Button
              onClick={handleCancel}
              type="button"
              bname="Cancel"
              name="cancel"
              id="cancel"
              className="btn btn-light rounded-1"
            ></Button>
          </Col>
          <Col lg={6} className="text-end">
            <Button
              disabled={!check}
              onClick={handleNext}
              type="button"
              bname="Continue"
              name="continue"
              id="continue"
              className="btn btn-primary rounded-1"
            ></Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export { CustomerCoachingBookingStep4 };
